import { Icons } from './Icons.js';

export function BottomNav(activeTab, navigateTo) {
    const nav = document.createElement('nav');
    nav.className = "fixed bottom-0 w-full z-[2000] pb-safe";

    nav.innerHTML = `
        <div style="
            background: rgba(255,255,255,0.93);
            backdrop-filter: blur(20px);
            -webkit-backdrop-filter: blur(20px);
            border-top: 1px solid rgba(47,85,111,0.07);
            box-shadow: 0 -6px 32px rgba(47,85,111,0.07);
        ">
            <ul id="bottom-nav-list" style="display:flex;justify-content:space-around;align-items:center;height:64px;list-style:none;margin:0;padding:0;"></ul>
        </div>
    `;

    const tabs = [
        { id: 'home',         label: 'Home',    icon: 'home' },
        { id: 'arberia-blog', label: 'Blog',    icon: 'blog' },
        { id: 'voci-arberia', label: 'Atlante', icon: 'atlante' },
        { id: 'map',          label: 'Mappa',   icon: 'map' },
        { id: 'profile',      label: 'Profilo', icon: 'profile' }
    ];

    const ul = nav.querySelector('#bottom-nav-list');

    tabs.forEach(tab => {
        const isActive = activeTab === tab.id;
        const li = document.createElement('li');
        li.style.cssText = 'flex:1;height:100%;';

        const activeColor = '#2F556F';
        const mutedColor = '#8fa3b0';

        const btn = document.createElement('button');
        btn.style.cssText = `
            width:100%;height:100%;
            display:flex;flex-direction:column;align-items:center;justify-content:center;
            gap:4px;background:none;border:none;cursor:pointer;
            position:relative;padding:0;
            transition:opacity 0.2s ease;
        `;

        btn.innerHTML = `
            <span style="
                display:flex;align-items:center;justify-content:center;
                transition: transform 0.25s ease;
                transform: ${isActive ? 'scale(1.12) translateY(-1px)' : 'scale(1)'};
                color: ${isActive ? activeColor : mutedColor};
            ">${Icons[tab.icon] ? Icons[tab.icon](22, isActive ? activeColor : mutedColor) : ''}</span>
            <span style="
                font-family:'Inter',sans-serif;
                font-size:8.5px;
                font-weight:${isActive ? '700' : '500'};
                letter-spacing:0.06em;
                text-transform:uppercase;
                color:${isActive ? activeColor : mutedColor};
                transition:color 0.25s ease;
            ">${tab.label}</span>
            ${isActive ? `<span style="
                position:absolute;bottom:7px;
                width:18px;height:2.5px;
                background:${activeColor};
                border-radius:999px;
            "></span>` : ''}
        `;

        li.onclick = () => { if (!isActive) navigateTo(tab.id); };
        li.appendChild(btn);
        ul.appendChild(li);
    });

    return nav;
}
